export default __webpack_public_path__ + "static/media/fridge.4b60582a.svg";